import { atom, useRecoilState } from 'recoil'

const filtersProjectsState = atom({
  key: 'ProjectsFilters',
  default: {
    state: 'in_progress',
    services: []
  }
})

const sortProjectsState = atom({
  key: 'ProjectsSort',
  default: {
    by: 'created_at',
    direction: 'desc'
  }
})

const sortServicesState = atom({
  key: 'ServicesSort',
  default: {
    by: 'mes_at',
    direction: 'desc'
  }
})
export const useProjectsFilters = () => {
  return useRecoilState(filtersProjectsState)
}

export const useProjectsSort = ():  [{ direction: string; by: string }, (sort: string) => void] => {
  const [{ direction, by }, setSort] = useRecoilState<{direction: string, by: string}>(sortProjectsState)
  return [
    { direction, by },
    sort => {
      if (by === sort) {
        const newDirection = direction === 'asc' ? 'desc' : 'asc'
        setSort({ by: sort, direction: newDirection })
      } else {
        setSort({ by: sort, direction: 'asc' })
      }
    }
  ]
}

export const useServicesSort = ():  [{ direction: string; by: string }, (sort: string) => void] => {
  const [{ direction, by }, setSort] = useRecoilState<{direction: string, by: string}>(sortServicesState)
  return [
    { direction, by },
    sort => {
      if (by === sort) {
        const newDirection = direction === 'asc' ? 'desc' : 'asc'
        setSort({ by: sort, direction: newDirection })
      } else {
        setSort({ by: sort, direction: 'asc' })
      }
    }
  ]
}